import i18n from 'i18next';
import Fetch, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { i18nextPlugin } from 'translation-check';

// const resources = {
//     en: {
//       translation: {
//         "Welcome to React": "<italic>Welcome</italic> to <bold>React</bold> and react-i18next {{count}}",
//         "Test": "tests"
//       }
//     },
//     fr: {
//       translation: {
//         "Welcome to React": "<italic>Bienvenue</italic> à <bold>React</bold> et react-i18next {{count}}"
//       }
//     }
// };

i18n
    .use(Fetch)
    .use(i18nextPlugin)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}?format=json',
            addPath: '/locales/{{lng}}/{{ns}}/add?format=json',
            saveMissing: true
        } as HttpBackendOptions,
        //resources,
        interpolation: {
            escapeValue: false  
        },
        fallbackLng: 
            // 'ko',
            'en',
        debug: true,
        saveMissing: true
    });

console.log(i18n.language);

export default i18n;